<div class="{{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="creative-title primary-color">
				{{ sectiontitle }} {{ timezone }}
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon daypart_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i *ngIf="!downloadIcon && !downloadConfiguration?.enablePNG" class="fa fa-download" aria-hidden="true"></i>
						<img
							*ngIf="!downloadIcon && downloadConfiguration?.enablePNG"
							src="../../../../../assets/creative-assets/download.svg"
						/>
						<img *ngIf="downloadIcon" class="downloadIcon" src="{{ downloadIcon }}" />
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content daypart-portlet-content" style="position: relative">
			<div class="o-stack o-stack--nowrap o-stack--center daypart-div" *ngIf="hasData">
				<div class="chart-div">
					<app-donut
						class="chartelement"
						(hightLightLabels)="hightLightLabels($event)"
						[chartConfigurationObj]="chartConfigObj"
						[chartData]="daypartChartObjArray[0]?.chartObj"
					>
					</app-donut>
					<div class="chartDateRange">{{ startDate }} - {{ endDate }}</div>
				</div>
				<div class="table-div">
					<ngx-datatable
						class="datatable v5datatable networks-shows-table"
						[rows]="daypartChartObjArray[0]?.chartObj"
						[cssClasses]="cssClasses"
						[columnMode]="'force'"
						[headerHeight]="50"
						[footerHeight]="footerHeight"
						[rowHeight]="rowHeight"
						[reorderable]="reorderable"
						[scrollbarV]="isVerticalScrollable"
					>
						<ngx-datatable-column
							name="Time of Day"
							[resizeable]="false"
							prop="name"
							[cellClass]="'dayparts-cell'"
							[headerClass]="'dayparts-header'"
						>
							<ng-template let-row="row" let-rowIndex="i" let-value="value" ngx-datatable-cell-template>
								<span class="daypartRow">
									<span
										class="dots"
										[ngStyle]="{ background: row.color }"
										[ngClass]="{ 'highlight-dark': row.isHighlighted }"
										[title]="getTitle(row.name, row.dayparttime)"
									></span>
									<span class="daypartName">{{ row.name }}</span>
								</span>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							[name]="sectionclass == 'midcoDayPartClass' ? 'Exposures' : daypartLabel"
							[resizeable]="false"
							prop="y"
							[cellClass]="'airedspots-cell'"
							[headerClass]="'airedspots-header'"
						>
							<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
								<span class="airepSpot">{{ row.y | number }}</span>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData" style="height: 417px">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
